import { Component } from "react";
import GetIcon from "./GetIcon.tsx";
import { Stack, Typography } from "@mui/material";

export default class DashLabel extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Stack direction="row" alignItems="center" gap={1} flex={1}>
                <Typography color="primary"><GetIcon props={{ size: 24 }} icon={this.props.icon} /></Typography>
                <Stack>
                    <Typography color="primary" variant="caption"><b>{this.props.title}</b></Typography>
                    <Typography color="primary" variant="h4"><b>{this.props.subtitle}</b></Typography>
                </Stack>
            </Stack>
        );
    }
}
